import { CancelToken } from "axios";
import LinkHeader from "http-link-header";
import _keyBy from "lodash/keyBy";
import qs from "qs";

export function queryPaginationTransform(response) {
  const total = response.headers.get("total");
  const link = response.headers.get("link");
  const page = response.headers.get("page");
  const perPage = response.headers.get("per-page");
  const links = link ? _keyBy(LinkHeader.parse(link).refs, "rel") : null;
  return {
    links,
    page: parseInt(page, 10),
    total: parseInt(total, 10),
    perPage: parseInt(perPage, 10)
  };
}

export function axiosPaginationTransform(response) {
  const {
    headers: { total },
    config: { params }
  } = response;
  const links = response.headers.link
    ? _keyBy(LinkHeader.parse(response.headers.link).refs, "rel")
    : null;

  return {
    links,
    params,
    total: parseInt(total, 10)
  };
}

export function paginatedResponseTransform(response, meta) {
  const { data } = response;
  const pagination = queryPaginationTransform(meta.response);
  return { data, pagination };
}

export const qsSettings = { arrayFormat: "brackets", encode: false };

export async function performRequest(requestFunc, path, params = {}) {
  const response = await requestFunc(path, {
    params,
    paramsSerializer(p) {
      return qs.stringify(p, qsSettings);
    }
  });
  // If error is thrown, the error.response is transformed via
  // requestErrorTransform called in the catch block of requestErrorWrapper
  return response.data?.data;
}

export async function performPaginatedRequest(requestFunc, path, params = {}) {
  const response = await requestFunc(path, {
    params,
    paramsSerializer(p) {
      return qs.stringify(p, qsSettings);
    }
  });
  const data = response.data?.data;

  const pagination = axiosPaginationTransform(response);
  // If error is thrown, the error.response is transformed via
  // requestErrorTransform called in the catch block of requestErrorWrapper
  return { data, pagination };
}

// This function reassigns the token to function passed to the callback in axios.CancelToken.
// JS primitive values are passed by value, but objects are passed by reference. To persist the
// assigned cancel callback, the cancelToken parameter must be an object.
/* eslint-disable no-param-reassign */
export async function performCancellableRequest(
  requestFunc,
  path,
  params = {},
  cancelToken = {}
) {
  if (cancelToken.token) {
    cancelToken.token("Canceled redundant request");
    // reset the cancel function if the request is cancelled
    cancelToken.token = null;
  }
  const response = await requestFunc(path, {
    cancelToken: new CancelToken(c => {
      cancelToken.token = c;
    }),
    params,
    paramsSerializer(p) {
      return qs.stringify(p, qsSettings);
    },
    headers: {
      "Content-Type": "application/json"
    }
  });
  // eslint-disable-next-line prefer-destructuring
  const data = response.data?.data;
  // reset the cancel function once the request completes
  cancelToken.token = null;

  if (params.page) {
    const pagination = axiosPaginationTransform(response);
    return { data, pagination };
  }
  // If error is thrown, the error.response is transformed via
  // requestErrorTransform called in the catch block of requestErrorWrapper
  return data;
}
/* eslint-enable no-param-reassign */
